@if (activeItem) {
  <div class="panoramer-backdrop">
    <div class="panoramer-panel" (click)="$event.stopPropagation()">
      <div class="panoramer-header">
        <span class="panoramer-counter">{{ currentPosition }} / {{ totalCount }}</span>
        <div class="panoramer-header-actions">
          <button class="btn btn-secondary btn-sm" (click)="move()">Move</button>
          <button class="btn btn-secondary btn-sm" (click)="skipCurrent()">Skip</button>
          <button class="panoramer-close" (click)="cancelAll()">&#10005;</button>
        </div>
      </div>
      <div class="panoramer-progress">
        <div class="panoramer-progress-bar"
          [style.width.%]="totalCount ? (processedCount / totalCount) * 100 : 0">
        </div>
      </div>
      @if (viewerVisible) {
        <app-panoramer-view
          [fileUrl]="getSafeUrl(activeItem.fileUrl)"
          [makeScreenShoot]="true"
          [selectedDamage]="activeItem"
          (onClosePanoramoPopup)="cancelAll()"
          (onLoadError)="onViewerError()"
          (onAutoScreenshot)="onAutoScreenshot($event)">
        </app-panoramer-view>
      }
    </div>
  </div>
}
